// Single source of truth for the event ticket display name:
// prefer the main part of the splitted category name, then the full
// category name, then the raw ticket name.
export const getEventTicketCategoryName = (ticket: any): string | undefined =>
  ticket?.splittedCategoryName?.main || ticket?.categoryName || ticket?.name;
